var _defs, _rect, _circle, _rect2, _text, _circle2, _path, _text2, _text3, _rect3, _text4, _circle3, _circle4, _path2, _text5, _text6, _rect4, _text7, _circle5, _rect5, _path3, _text8, _text9, _rect6, _text0, _circle6, _circle7, _path4, _text1, _text10, _rect7, _text11, _circle8, _circle9, _path5, _text12, _text13, _rect8, _text14, _circle0, _circle1, _path6, _text15, _text16, _path7, _path8, _path9, _path0, _path1, _rect9, _circle10, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportRequirementsModelLiveRelationshipMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1260,
    viewBox: "0 0 620 1260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport requirements model mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wp-model-glow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 1260,
    rx: 34,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 604.8,
    r: 360,
    fill: "url(#wp-model-glow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 78,
    width: 500,
    height: 150,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 112,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "01")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 162,
    r: 34,
    fill: "#087CFF",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113 175v-27h30v27M120 155h3m5 0h3m5 0h3M120 163h3m5 0h3m5 0h3M110 175h36",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 153,
    textAnchor: "start",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "SITE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 184,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 0
  }, "Configure each"), /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 26
  }, "worksite"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 265,
    width: 500,
    height: 150,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 299,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "02")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 349,
    r: 34,
    fill: "#FF2775",
    fillOpacity: 0.12
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 341,
    r: 7,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 363c1-9 6-13 13-13s12 4 13 13M121 354l7 6 7-6",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 340,
    textAnchor: "start",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "POSITION")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 371,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 0
  }, "Define each role"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 452,
    width: 500,
    height: 150,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 486,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "03")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 536,
    r: 34,
    fill: "#F5B642",
    fillOpacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 519,
    width: 28,
    height: 34,
    rx: 3,
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121 528h14M121 535h9M121 544l4 4 9-10",
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 527,
    textAnchor: "start",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "REQUIREMENTS")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 558,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 0
  }, "Set current criteria"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 639,
    width: 500,
    height: 150,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 673,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "04")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 723,
    r: 34,
    fill: "#74BDFF",
    fillOpacity: 0.12
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 714,
    r: 8,
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113 738c2-10 7-15 15-15s13 5 15 15",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 714,
    textAnchor: "start",
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "EMPLOYEE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 745,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 0
  }, "Allocate the"), /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 26
  }, "workforce"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 826,
    width: 500,
    height: 150,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 860,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "05")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 910,
    r: 34,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 910,
    r: 17,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 900v11l8 5",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 901,
    textAnchor: "start",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "VALIDITY")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 932,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 0
  }, "Track evidence"), /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 26
  }, "and expiry"))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 1013,
    width: 500,
    height: 150,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 1047,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "06")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 1097,
    r: 34,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 1097,
    r: 17,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120 1097l6 6 11-13",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 1088,
    textAnchor: "start",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "READINESS")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 1119,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 0
  }, "Determine"), /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    dy: 26
  }, "deployment status"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310 228v37m-7-8 7 8 7-8",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M310 415v37m-7-8 7 8 7-8",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M310 602v37m-7-8 7 8 7-8",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M310 789v37m-7-8 7 8 7-8",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M310 976v37m-7-8 7 8 7-8",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 1200,
    width: 500,
    height: 1,
    fill: "#29405D"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 1232,
    r: 6,
    fill: "#30D6A1"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 1233,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 98,
    dy: 0
  }, "A live model recalculates readiness whenever"), /*#__PURE__*/React.createElement("tspan", {
    x: 98,
    dy: 21
  }, "requirements, evidence or allocations change."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportRequirementsModelLiveRelationshipMobile);
export default __webpack_public_path__ + "static/media/work-passport-requirements-model-live-relationship-mobile.6219bdbb4b8d1d30b36a6e54f062822e.svg";
export { ForwardRef as ReactComponent };